<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <BoxPaciente
                ref="BoxPaciente"
                :data="data"
            />

            <rkm-area
                v-if="pacienteExists"
                type="section"
                title="Incluir agendamento retroativo"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-row>
                            <rkm-col cols="8">

                                <rkm-form-input
                                    label="Médico solicitante"
                                    v-if="agendamento.alterar == true"
                                    v-model="agendamento.medicoNome"
                                    disabled
                                />

                                <rkm-form-input-autocomplete
                                    v-if="agendamento.alterar == false"
                                    :repository="repositories.usuario"
                                    :requestQueryStringParams="{ with_not_regularized: true }"
                                    :searchFields="fields.autocomplete.usuario"
                                    :validations="validations.medicoSolicitante"
                                    label="Médico solicitante"
                                    placeholder="Digite o nome ou número do conselho profissional"
                                    v-model="agendamento.medicoSolicitante"
                                    text-field="cidadaoNome"
                                    :disabled="agendamento.alterar ? true : false"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <rkm-form-checkbox
                                    v-model="agendamento.urgente"
                                    inline
                                    :label="false"
                                    :disabled="agendamento.alterar ? true : false"
                                >
                                    Agendamento urgente
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col
                                cols="12"
                                v-if="this.data.form.paciente.cidadao.idade.anos < 18 || this.data.form.paciente.cidadao.idade.anos >= 60"
                            >
                                <rkm-form-input
                                    label="Responsável pelo paciente"
                                    v-model="agendamento.nomeResponsavel"
                                    uppercase
                                    :disabled="agendamento.alterar ? true : false"
                                />
                            </rkm-col>

                            <rkm-col cols="6" v-if="!isReadOnly">
                                <rkm-form-select
                                    :options="unidadeExecutante"
                                    label="Unidade executante"
                                    show-default-option
                                    text-field="unidadeNome"
                                    v-model="agendamento.unidadeId"
                                    value-field="unidadeId"
                                    :validations="validations.medicoExecutante"
                                    :disabled="!agendamento.medicoSolicitante || agendamento.alterar ? true : false"
                                    @change="$emit('setFields','unidadeExecutante','resetGrupoExame')"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    label="Local de atendimento"
                                    :options="infraestruturas"
                                    textField="nomeInfraestrutura"
                                    v-model="agendamento.infraestruturaId"
                                    valueField="infraestruturaId"
                                    show-default-option
                                    :validations="validations.infraestruturaId"
                                    :disabled="!agendamento.unidadeId || agendamento.alterar ? true : false"
                                    @change="$emit('setFields','infraestruturaId')"
                                />
                            </rkm-col>

                            <rkm-col cols="6" v-if="agendamento.alterar == false">
                                <rkm-form-select
                                    :options="grupo"
                                    label="Grupo de exame"
                                    show-default-option
                                    text-field="exameNome"
                                    v-model="agendamento.grupoExameId"
                                    value-field="exameId"
                                    :validations="validations.grupoExameId"
                                    :disabled="!agendamento.infraestruturaId
                                        || agendamento.alterar ? true : false"
                                    @change="$emit('setFields','grupoExameId','resetProfissional')"
                                />
                            </rkm-col>

                            <rkm-col cols="6" v-if="agendamento.alterar == true">
                                <rkm-form-input
                                    label="Grupo de exame"
                                    v-model="agendamento.grupoExameNome"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col cols="6" v-if="agendamento.alterar == false">
                                <rkm-form-select
                                    :options="profissional"
                                    label="Profissional executante"
                                    show-default-option
                                    text-field="profissionalNome"
                                    v-model="agendamento.profissionalId"
                                    value-field="profissionalId"
                                    :validations="validations.medicoExecutante"
                                    :disabled="!agendamento.grupoExameId
                                        || agendamento.alterar ? true : false"
                                    @change="$emit('setFields','profissionalId')"
                                />
                            </rkm-col>

                            <rkm-col cols="6" v-if="agendamento.alterar == true">
                                <rkm-form-input
                                    label="Profissional executante"
                                    v-model="agendamento.profissionalNome"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col cols="12" v-if="agendamento.data">

                                <rkm-area title="Exame(s)" no-margin-top>
                                    <rkm-row>
                                        <rkm-col cols="12">
                                            <rkm-list
                                                :items="agendamento.incluido"
                                                :fields="fields.tables.exame"
                                                hide-filters
                                                hide-pagination
                                                item-cursor="default"
                                            >
                                                <template v-slot="{ item }">
                                                    {{ getExame(item) }}
                                                </template>
                                            </rkm-list>
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>

                            <rkm-col class="flex-grow-1 mt-1">
                                <rkm-form-date-picker
                                    v-if="agendamento.data"
                                    label="Data"
                                    v-model="agendamento.data"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-time-picker
                                    v-if="agendamento.data"
                                    label="Horário"
                                    v-model="agendamento.horaExame"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col cols="12">
                                <rkm-form-textarea
                                    label="Observação"
                                    v-model="agendamento.observacao"
                                    :validations="validations.observacao"
                                    rows="4"
                                    max-rows="4"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-col class="flex-grow-1">
                            <rkm-calendar
                                :items="diasCalendario"
                                @click="openModal"
                            />
                        </rkm-col>

                        <rkm-row class="flex-grow-1 ml-2">
                            <rkm-icon
                                icon="exclamation-circle"
                                class="leg-verde d-flex float-left"
                                small
                            />
                            <rkm-col class="mt-1 pt-0">
                                vagas disponíveis
                            </rkm-col>

                            <rkm-icon
                                icon="exclamation-circle"
                                class="leg-azul d-flex float-left"
                                small
                            />
                            <rkm-col class="mt-1 pt-0">
                                data selecionada
                            </rkm-col>

                            <rkm-icon
                                icon="exclamation-circle"
                                class="leg-vermelho d-flex float-left"
                                small
                            />
                            <rkm-col class="mt-1 pt-0">
                                vagas atingidas
                            </rkm-col>

                            <rkm-icon
                                icon="exclamation-circle"
                                class="leg-amarelo d-flex float-left"
                                small
                            />
                            <rkm-col class="mt-1 pt-0">
                                feriado/facultativo
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <ModalExames
            ref="RkmModalExames"
            :data="data"
            :vagas="vagas"
            :jornadas="jornadas"
            :vagasPreenchidas="vagasPreenchidas"
            :horaSave="horaSave"
            :agendamento="agendamento"
            @handleAgendamento="handleAgendamento"
            @openModal="openModal"
        />

        <ModalPermissao
            ref="RkmModalPermissao"
            @openModal="openModal"
        />
    </div>
</template>

<script>

// Mixins.
import { error, repository, stringCase, object, data, calculations, formats } from '@/mixins'

// Components.
import ModalExames from '@/components/exame-imagem/agendamento-retroativo/tabs/cadastro/components/exames/Modal'
import ModalPermissao from '@/components/exame-imagem/agendamento-retroativo/tabs/cadastro/components/permissao/Modal'
import BoxPaciente from '@/components/exame-imagem/agendamento-retroativo/paciente/Index'

// Filters.
import format from '@/filters/formats'

// Enuns.
import modulo from '@/enums/cadastro/feriado/modulo'
import sexo from '@/enums/cadastro/cidadao/sexo'

// Moment.
import moment from 'moment'

export default {
    components: { ModalExames, BoxPaciente, ModalPermissao},
    computed:{
        pacienteExists() {
            return this.data.form && this.data.form.paciente
        },
        hasIndex() {

            return this.index !== null
        },
        infraestruturas() {

            if (this.agendamento.unidadeId) {

                let infraestruturaPrincipal = this.unidadeExecutante.find(u => u.unidadeId === this.agendamento.unidadeId)

                if (infraestruturaPrincipal) {

                    this.$emit('loadInfraestrutura', infraestruturaPrincipal.infraestruturas)

                    return infraestruturaPrincipal.infraestruturas
                }
            }

            return []
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: 'cadastroCidadao.nome', searchable: true },
                        { key: "registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
                tables: {
                    exame: [
                        { key: 'nome', label: 'Exame(s) incluído(s)', sortable: true },
                    ],
                }
            }
        },
        validations() {
            return {
                unidadeId: { required: true },
                infraestruturaId: { required: true },
                grupoExameId: { required: true },
                medicoSolicitante: { required: true },
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                observacao: { min: 3, max: 500 }
            }
        },
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamentoRetroativo'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            feriado: this.getConectaSusRepository('cadastro.feriado.feriado'),
            responsavel: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }

        if (this.data.model) {

            this.defaultItem = this.clone(this.data.model.item)
        }
    },
    data: () => ({
        notAuthorized: true,
        exames:[],
        unidadeNome: '',
        defaultItem: null,
        localResponsavel: {
            autocompleteFieldsResponsavel: {
                responsavel: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            },
        },
        enums: {
            modulo,
            sexo,
        },
        cadastro:[],
        isReadOnly: false,
        dataAtual: '',
        tabIndex: 1,
        checkData: '',
        alertSupervisor: null,
        jornada: null
    }),
    filters: {
        ...format,
    },
    methods: {
        disableField() {

            return this.data.model && Number(this.data.model.id) > 0
        },
        handleSaveItem() {

            this.data.model.item = this.clone(this.defaultItem)
        },
        handleSaveUsuarioSimplificado(usuario) {

            if (usuario) {

                this.agendamento.medicoSolicitante = this.clone(usuario)

                this.agendamento.medicoSolicitante.cidadaoNome = usuario.nome
            }
        },
        openModal(item, autorizacao, supervisorId){

            if(autorizacao == false){

                this.notAuthorized = autorizacao
            }

            if(supervisorId){

                this.agendamento.supervisorId = supervisorId
            }

            let dataCalendario = item.attributes[0].customData.title.split('/')

            let feriado = []

            this.data.form.feriados.map(feriadoExameImagem =>

                feriado.push(feriadoExameImagem)
                 
            )

            const jornadas = this.jornadas.filter(u => u.exameId === this.agendamento.grupoExameId
                && u.profissionalId === this.agendamento.profissionalId
                && u.unidadeId === this.agendamento.unidadeId)

            var diaTratado = moment(item.date).format('DD/MM/YYYY')
                diaTratado = diaTratado.split("/").reverse().join("-")

            let dataAtual = this.data.form.dataAtual
                dataAtual = dataAtual.split("/").reverse().join("-")

            const diaSelecionado = jornadas.find(
                dias => dias.data.split("/").reverse().join("-") == diaTratado
            )

            const isFeriado = feriado.some(f =>
                f.data.split("/").reverse().join("-") === diaTratado
            )

            if (isFeriado) {    
                return false
            }

            if(diaSelecionado.vagas <= dataCalendario && diaTratado !== this.agendamento.data && this.notAuthorized){

                const confirm = async () => {

                    this.alertSupervisor = this.agendamento.agendamentoId

                    this.$refs.RkmModalPermissao.open(item)

                    return false
                }

                const cancel = async () => {}

                const msg = 'O número de vagas foi atingido, para continuar é necessário informar' +
                    ' os dados do supervisor. Deseja continuar?'

                this.showConfirmation(msg, confirm, cancel)

                return false

            } else if(diaSelecionado && moment(diaTratado).isBefore(dataAtual)
                || diaSelecionado && diaTratado == this.agendamento.data){

                    this.$refs.RkmModalExames.open(diaSelecionado, jornadas, dataCalendario[0], this.notAuthorized)

                    this.notAuthorized = true
            }
        },
        handleAgendamento(value, itemSelecionado, horarioAtendimento, jornada){

            if (value.length > 0) {

                this.exames = value
            }

            this.jornada = jornada

            this.itemSelecionado = itemSelecionado

            if (horarioAtendimento !== null) {

                this.agendamento.horaExame = horarioAtendimento
            }

            let agendarExames = []

            value.map(e => agendarExames.push({
                'exameInternoId': e.exameInternoId,
                'exameInternoNome': e.exameInternoNome,
                'exameNome': itemSelecionado.exameNome,
                'exameHorario': e.horaExame
            }))

            this.preparaAgendamento(value, itemSelecionado, jornada)
        },
        preparaAgendamento(value, itemSelecionado, jornada){

            const infraestrutura = this.data.form.unidadesPrestadoras.find(unidade => unidade.infraestruturaId == this.agendamento.infraestruturaId)

            if(infraestrutura){
                this.agendamento.infraestruturaNome = infraestrutura.infraestruturaNome
                this.agendamento.endereco = infraestrutura.endereco
                this.agendamento.numero = infraestrutura.numeroEndereco
                this.agendamento.bairro = infraestrutura.bairro
                this.agendamento.telefone = infraestrutura.telefone
            }

            this.agendamento.exames = itemSelecionado.exames
            this.agendamento.data = itemSelecionado.data.split("/").reverse().join("-")
            this.agendamento.profissionalId = itemSelecionado.profissionalId
            this.agendamento.profissionalNome = itemSelecionado.profissionalNome
            this.agendamento.infraestruturaNome = itemSelecionado.infraestruturaNome
            this.agendamento.unidadeId = itemSelecionado.unidadeId
            this.agendamento.unidadeNome = itemSelecionado.unidadeNome
            this.agendamento.medicoId = this.agendamento.medicoSolicitante.id
            this.agendamento.medicoNome = this.agendamento.medicoSolicitante.nome
            this.agendamento.exameNome = itemSelecionado.exameNome

            if (value.length > 0) {
                this.agendamento.incluido = value
            }

            this.agendamento.pacienteId = this.data.form.paciente.id
            this.agendamento.jornadaId = jornada
            this.agendamento.agendadorId = this.data.form.usuarioSistemaId

            this.$emit('alterCalendar', this.agendamento.data)
        },
        getExame(item) {

            return item.codigo ? `${item.codigo} - ${item.nome}` : item.nome
        },
        validate() {

            return this.$refs.Form.validate()
        },
        resetValidate() {

            this.$refs.Form.resetValidator()
        }
    },
    mixins: [ error, repository, stringCase, object, data, calculations, formats],
    props: {
        data: { type: Object, required: true },
        feriado: { type: Array, default: null },
        vagas: { type: Array, required: true },
        vagasPreenchidas: { type: Number, default: null },
        horaSave: { type: String, default: null },
        agendamento: { type: Object, required: true },
        index: { type: Number, default: null },
        diasCalendario: {type: Array, required: true},
        jornadas: { type: Array, required: true },
        unidadeExecutante: { type: Array, required: true },
        grupo: { type: Array, required: true },
        profissional: { type: Array, required: true },
    },
    watch: {
        'feriado': function () {

            let diasCalendario = []

            this.data.form.feriados.map(feriado => {

                diasCalendario.push({
                    'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                    'highlight': 'yellow',
                    'title': feriado.tipoNome,
                    'popover':  feriado.observacao
                })
                  
            })

            this.$emit('loadDiasCalendario', diasCalendario)
        },
    }
}
</script>

<style scoped>
.calendario {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.calendario img {
    max-width: 100%;
    max-height: 100%;
    margin: 1rem 0;
}
.form-group-radio-button-disabled, .form-group-checkbox-button-disabled {
    width: 100%
}
p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
.leg-verde {
    color: #38a169;
    margin-top: 10px;
}
.leg-azul {
    color: #3182ce;
    margin-top: 10px;
}
.leg-vermelho {
    color: #e53e3e;
    margin-top: 10px;
}
.leg-amarelo {
    color: #d69e2e;
    margin-top: 10px;
}
</style>

